import React, {FC} from 'react';
import {SeverCustomerAuthTokenProvider} from './SeverCustomerAuthTokenProvider';
import {BasketTokenProvider} from './basketStore/BasketTokenProvider';
import {MinimalStateProvider} from './basketStore/useBasketMinimalState';
import {CustomerProvider} from './customer/customer.hooks';
import {CustomerSessionValidProvider} from './customerSessionValidStore/customerSessionValidStore.hook';
import {SessionProvider} from './sessionStore/session.hooks';
import {UserProvider} from './userStore/user.hooks';
import {OptionalUserProvider} from './userStore/userOptionalData.hooks';
import {WishlistStateProvider} from './wishlistStore/useWishlistState';

export const UserStateProvider: FC<
  React.PropsWithChildren<{
    UserSelectedDiscountProvider: FC<React.PropsWithChildren>;
    authToken?: string;
  }>
> = ({children, UserSelectedDiscountProvider, authToken}) => {
  return (
    <SeverCustomerAuthTokenProvider authToken={authToken}>
      <SessionProvider>
        <UserProvider>
          <OptionalUserProvider>
            <UserSelectedDiscountProvider>
              <WishlistStateProvider>
                <CustomerSessionValidProvider>
                  <BasketTokenProvider>
                    <MinimalStateProvider>
                      <CustomerProvider>{children}</CustomerProvider>
                    </MinimalStateProvider>
                  </BasketTokenProvider>
                </CustomerSessionValidProvider>
              </WishlistStateProvider>
            </UserSelectedDiscountProvider>
          </OptionalUserProvider>
        </UserProvider>
      </SessionProvider>
    </SeverCustomerAuthTokenProvider>
  );
};
